module.exports = __webpack_public_path__ + "static/valerian-4de4deed5ebec0d4bbc96d076eff9874.png";